var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChesedOpportunites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.258,
    cy: 16.839,
    r: 16.5,
    fill: "#F1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.395 10.339c-1.528 0-2.837.8-3.637 1.963-.8-1.163-2.109-1.963-3.636-1.963a4.376 4.376 0 0 0-4.364 4.364c0 4.363 8 10.909 8 10.909s8-6.546 8-10.91c0-2.4-1.963-4.363-4.363-4.363z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChesedOpportunites);
export default __webpack_public_path__ + "static/media/chesed-opportunites.f14bb057699d38e27251b5e6bc40c5ef.svg";
export { ForwardRef as ReactComponent };